import { useCallback, useEffect } from "react";
import TransTable from "../../common/TransTable";
import _ from "lodash";
import { Box, Button, IconButton, Typography } from "@mui/material";
import { useDispatch } from "react-redux";
import { setSelectedLeagues } from "../../../redux/action";
import { Link, useNavigate } from "react-router-dom";
import Capsule from "../../common/Capsule";
import Axios from "axios";
import { base_url } from "../../backendurl/url";
import { useState } from "react";
import ModalPopUp from "../../common/TransForm/ModalPopUp";
import { Config } from "../../../utils/commonFuctions/Token";
import { RefreshToken } from "../../../utils/commonFuctions/RefreshToken";
import { Notification } from "../../common/Notification";
import { Edit, Delete } from "@mui/icons-material";
import { hasWritePermission } from "../../common/PermissionUtility";

const placements = {
    "landing_page": "Landing Page Hero",
    "landing_page_mobile": "Landing Page Hero Mobile",
    "landing_rounds": "Landing Page Section 2",
    "home": "Home Page",
    "rounds_page": "Rounds Page"
}

export default function AdvBannersList() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch();
  const [advBannerList, setAdvBannerList] = useState([])
  const [popup, setPopup] = useState(false)
  const [advBannerDetails, setAdvBannerDetails] = useState({})
  const [notification, setnotification] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  
  // Delete confirmation modal states
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false)
  const [deleteMessage, setDeleteMessage] = useState('')
  const [itemToDelete, setItemToDelete] = useState(null)
  const canWriteUsers = hasWritePermission('advbanner');

  // Custom search function
  const customSearch = (data, query) => {
    if (!query) return data;
    
    const searchQuery = query.toLowerCase();
    
    return data.filter(item => {
      // Search in name field
      const nameMatch = item.name && item.name.toLowerCase().includes(searchQuery);
      
      // Search in placement field (using display names)
      const placementDisplay = placements[item.placement] || item.placement;
      const placementMatch = placementDisplay && placementDisplay.toLowerCase().includes(searchQuery);
      
      // Search in enabled field (Active/Inactive)
      const statusText = item.enabled ? 'active' : 'inactive';
      const statusMatch = statusText.includes(searchQuery);
      
      // Search in league_season_display_name if available
      const leagueMatch = item.league_season_display_name && 
                         item.league_season_display_name.toLowerCase().includes(searchQuery);
      
      return nameMatch || placementMatch || statusMatch || leagueMatch;
    });
  };

  const advTableColumns = () => [
    {
      key: "name",
      label: "Name",
      align: "left",
      fontSize: '15px',
      valueRenderer: (data) => {
        return (
          <Box>
            <Link
              component={Typography}
              style={{ color: "black", textDecoration: "none" }}
            >
              {data["name"]}
            </Link>
            {/* Display League Season Display Name if available */}
            {data.league_season_display_name && (
              <Typography variant="body2" style={{ color: "#666", fontSize: "12px" }}>
                {data.league_season_display_name}
              </Typography>
            )}
          </Box>
        );
      },
    },
    { 
      key: "placement", 
      label: "Location", 
      align: "left", 
      fontSize: "15px",
      valueRenderer: (data) => {
        return (
          <Link
            component={Typography}
            style={{ color: "black", textDecoration: "none" }}
          >
            {placements[data["placement"]]}
          </Link>
        );
      },
    },
    {
      key: "image",
      label: "Image",
      align: "center",
      valueRenderer: (data) => {
        if (data.image) {
          return (
            <div className="flex justify-center items-center">
              <img
                src={data.image}
                style={{ maxWidth: "140px", maxHeight: "100px" }}
                alt="Banner"
              />
            </div>
          );
        } else {
          return <></>;
        }
      },
    },
    {
      key: "enabled",
      label: "Status",
      align: "center",
      fontSize: '14px',
      valueRenderer: (data) => {
        if (data.enabled === true) {
          return <Capsule data='Active' bgColor='#21965333' color='#219653' />;
        } else {
          return <Capsule data='Inactive' bgColor='#87878714' color='#64748B' />;
        }
      },
    },
    ...(canWriteUsers ? [{
      key: "action",
      label: "Activate/Deactivate",
      align: "center",
      valueRenderer: (data) => {
        return (
          <Box>
            <Button 
              onClick={() => onHandelClick(data)} 
              sx={{ 
                backgroundColor: '#F1F5F9', 
                color: '#3C50E0', 
                fontSize: '14px', 
                borderRadius: '6px' 
              }}
            >
              {data.enabled === true ? 'Deactivate' : 'Activate'}
            </Button>
          </Box>
        );
      },
    },
    {
      key: "edit_action",
      label: "Edit",
      align: "center",
      valueRenderer: (data) => {
        return (
          <Box>
            <IconButton 
              onClick={() => onEditBtnClick(data)} 
              sx={{ 
                backgroundColor: '#F1F5F9', 
                color: '#3C50E0', 
                fontSize: '14px', 
                borderRadius: '6px' 
              }}
            >
              <Edit />
            </IconButton>
          </Box>
        );
      },
    },
    {
      key: "delete_action",
      label: "Delete",
      align: "center",
      valueRenderer: (data) => {
        return (
          <Box>
            <IconButton 
              onClick={() => onDeleteBtnClick(data)} 
              sx={{ 
                backgroundColor: '#ffebee', 
                color: '#d32f2f', 
                fontSize: '14px', 
                borderRadius: '6px' 
              }}
            >
              <Delete />
            </IconButton>
          </Box>
        );
      },
    }] : []),
  ];

  const onHandelClick = (data) => {
    setPopup(true)
    setAdvBannerDetails(data)
  }

  const onEditBtnClick = (data) => {
    setAdvBannerDetails(data);
    navigate(`edit/${data.id}`);
  }

  const onDeleteBtnClick = (data) => {
    setItemToDelete(data);
    setDeleteMessage(`Are you sure you want to delete the banner? This action cannot be undone.`);
    setDeleteConfirmOpen(true);
  }

  const confirmDelete = async () => {
    if (!itemToDelete) return;
    
    try {
      const response = await Axios.delete(`${base_url}/api/accounts/advbanners/${itemToDelete.id}/`, Config);
      if (response?.status === 200 || response?.status === 204) {
        setDeleteConfirmOpen(false);
        setItemToDelete(null);
        // Refresh the list after successful deletion
        await refreshAdvBannersList();
      }
    } catch (error) {
      RefreshToken(error, setErrorMessage, setnotification);
    }
  }

  const cancelDelete = () => {
    setDeleteConfirmOpen(false);
    setItemToDelete(null);
    setDeleteMessage('');
  }

  const SubmitChange = async () => {
    try {
      advBannerDetails.enabled = !advBannerDetails.enabled;
      const response = await Axios.put(`${base_url}/api/accounts/advbanners/${advBannerDetails.id}/`, advBannerDetails, Config);
      if (response?.status === 200) {
        setPopup(false);
        // Refresh the list after successful update
        await refreshAdvBannersList();
      }
    } catch (error) {
      RefreshToken(error, setErrorMessage, setnotification);
    }
  }

  const getAdvBannersList = useCallback(async () => {
    try {
      if (_.isEmpty(advBannerList) && !loading) {
        setLoading(true);
        const response = await Axios.get(`${base_url}/api/accounts/adv-banner/list`, Config);
        if (response?.status === 200) {
          console.log(response?.data);
          // Sort the data: Active banners first, then inactive
          const sortedData = response?.data.sort((a, b) => {
            // Active banners (enabled: true) should come first
            if (a.enabled === true && b.enabled === false) return -1;
            if (a.enabled === false && b.enabled === true) return 1;
            // If both have the same status, maintain original order
            return 0;
          });
          setAdvBannerList(sortedData);
        }
        setLoading(false);
      }
    } catch (error) {
      RefreshToken(error, setErrorMessage, setnotification);
      setLoading(false);
    }
  }, [advBannerList, loading]);

  // Separate function to force refresh the list
  const refreshAdvBannersList = async () => {
    try {
      setLoading(true);
      const response = await Axios.get(`${base_url}/api/accounts/adv-banner/list`, Config);
      if (response?.status === 200) {
        console.log(response?.data);
        // Sort the data: Active banners first, then inactive
        const sortedData = response?.data.sort((a, b) => {
          // Active banners (enabled: true) should come first
          if (a.enabled === true && b.enabled === false) return -1;
          if (a.enabled === false && b.enabled === true) return 1;
          // If both have the same status, maintain original order
          return 0;
        });
        setAdvBannerList(sortedData);
      }
      setLoading(false);
    } catch (error) {
      RefreshToken(error, setErrorMessage, setnotification);
      setLoading(false);
    }
  };

  const gotoAddUser = () => {
    navigate("add");
    setAdvBannerList(setSelectedLeagues({}));
  };

  const gotToViewUser = (data) => {
    navigate(`/${data.id}`);
  };

  useEffect(() => {
    getAdvBannersList();
  }, []);

  return (
    <>
      <Box>
        <TransTable
          pageTitle="Adv Banners"
          subTitle={'Configure adv banners for landing page, home page here'}
          addBtnTitle={'Create Adv Banner +'}
          checkbox={false}
          columns={advTableColumns({ gotToViewUser })}
          rows={advBannerList}
          addBtnAction={gotoAddUser}
          showSearch={true}
          filter_keys={['name', 'placement', 'enabled', 'league_season_display_name']}
          onSearch={customSearch}
          isLoading={loading}
          showAddBtn={canWriteUsers}
        />
        <Notification message={errorMessage} setopen={setnotification} type={'error'} show={notification} />
      </Box>
      
      {/* Active/Deactivate Confirmation Modal */}
      <ModalPopUp
        openpopup={popup}
        setPopup={setPopup}
        title={'Confirm the action ?'}
        subTitle={'Are you sure, you want to change the Adv Banner Status?'}
        onClick={SubmitChange}
        save={'Confirm'}
        cancel={'Exit'}
      />
      
      {/* Delete Confirmation Modal */}
      <ModalPopUp
        openpopup={deleteConfirmOpen}
        setPopup={setDeleteConfirmOpen}
        title={'Confirm Delete'}
        subTitle={deleteMessage}
        onClick={confirmDelete}
        save={'Delete'}
        cancel={'Cancel'}
        onCancel={cancelDelete}
      />
    </>
  );
}